/** Analytics Portal V1 — period-over-period chip (Phase 9). Never colour alone: an arrow
 * glyph and text carry the direction as well as the hue. */
import React from "react";
import { ArrowDownRight, ArrowUpRight, Minus, Sparkles } from "lucide-react";

const fmt = (value) => (typeof value === "number"
  ? value.toLocaleString(undefined, { maximumFractionDigits: 1 }) : value);

export const ComparisonChip = ({ metricKey, metric }) => {
  if (!metric || metric.available === false) return null;
  if (metric.is_new) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-accent px-2 py-0.5 text-xs font-[560] text-foreground"
            data-testid={`analytics-compare-${metricKey}`}>
        <Sparkles className="h-3 w-3" aria-hidden="true" /> New this period
      </span>
    );
  }
  if (metric.change === null || metric.change === undefined) return null;
  const up = metric.change > 0;
  const flat = metric.change === 0;
  const Icon = flat ? Minus : up ? ArrowUpRight : ArrowDownRight;
  const tone = flat ? "text-muted-foreground"
    : up ? "text-[hsl(160_70%_28%)]" : "text-[hsl(2_72%_44%)]";
  const label = flat ? "No change" : `${up ? "Up" : "Down"} ${fmt(Math.abs(metric.change))}`;
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-[560] ${tone}`}
          data-testid={`analytics-compare-${metricKey}`}>
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      <span className="sr-only">{label} versus the previous period. </span>
      <span aria-hidden="true">{flat ? "0" : `${up ? "+" : "−"}${fmt(Math.abs(metric.change))}`}</span>
      {metric.change_pct !== null && metric.change_pct !== undefined && (
        <span className="text-muted-foreground">({fmt(Math.abs(metric.change_pct))}%)</span>
      )}
    </span>
  );
};
